import { useNavigate, useLocation } from 'react-router-dom';

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { path: '/dashboard', icon: 'ri-home-5-line', activeIcon: 'ri-home-5-fill', label: 'Home' },
    { path: '/dashboard/transactions', icon: 'ri-exchange-funds-line', activeIcon: 'ri-exchange-funds-fill', label: 'History' },
    { path: '/dashboard/profile', icon: 'ri-user-6-line', activeIcon: 'ri-user-6-fill', label: 'Profile' }
  ];

  // Only show on dashboard pages, excluding mobile onboarding and admin
  const isDashboard = location.pathname === '/dashboard' || location.pathname.startsWith('/dashboard/');
  const isAdmin = location.pathname.startsWith('/admin');
  const isOnboarding = location.pathname === '/mobile/onboarding';

  if (!isDashboard || isAdmin || isOnboarding) {
    return null;
  }

  return (
    <nav className="fixed bottom-8 left-1/2 -translate-x-1/2 w-[92%] max-w-[400px] bg-white/70 backdrop-blur-2xl border border-white/40 shadow-[0_20px_50px_rgba(0,0,0,0.1)] rounded-[2.5rem] z-50 lg:hidden safe-area-inset-bottom ring-1 ring-black/5">
      <div className="flex justify-around items-center h-20 px-2">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.path}
              onClick={() => {
                if (window.navigator.vibrate) window.navigator.vibrate(10);
                navigate(item.path);
              }}
              className="relative flex flex-col items-center justify-center py-2 px-4 transition-all duration-300"
            >
              <div className={`
                flex flex-col items-center justify-center gap-1 transition-all duration-500
                ${isActive ? 'translate-y-[-4px]' : 'translate-y-0 opacity-40'}
              `}>
                <div className={`
                  w-12 h-12 rounded-[1.25rem] flex items-center justify-center transition-all duration-500
                  ${isActive ? 'bg-slate-900 text-white shadow-2xl shadow-slate-900/30' : 'text-slate-600'}
                `}>
                  <i className={`${isActive ? item.activeIcon : item.icon} text-xl`}></i>
                </div>
                <span className={`
                  text-[9px] font-black uppercase tracking-widest transition-all duration-500
                  ${isActive ? 'text-slate-900 opacity-100 mt-1' : 'opacity-0 scale-50 h-0'}
                `}>
                  {item.label}
                </span>
              </div>

              {isActive && (
                 <div className="absolute -bottom-1 w-1.5 h-1.5 bg-slate-900 rounded-full animate-in zoom-in duration-300"></div>
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
